import { PARTNERS } from "../lib/constants";

export default function Partners() {
  // Duplicamos a lista para criar loop infinito sem cortes
  const loop = [...PARTNERS, ...PARTNERS];

  return (
    <section
      id="parceiros"
      data-testid="partners-section"
      className="py-20 md:py-28 bg-white relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-12 reveal">
          <p className="text-sm font-bold uppercase tracking-[0.25em] text-[#00C7A5] mb-4">
            Quem confia no nosso trabalho
          </p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#2F5887] leading-tight mb-5">
            Nossos Parceiros
          </h2>
          <p className="text-[#4B5563] text-lg leading-relaxed">
            Empresas e profissionais que escolheram a Master Business para cuidar da sua contabilidade com excelência e proximidade.
          </p>
        </div>

        <div className="reveal partners-marquee group">
          {/* Gradientes laterais para fade */}
          <div className="partners-fade partners-fade-left" aria-hidden="true" />
          <div className="partners-fade partners-fade-right" aria-hidden="true" />

          <div className="partners-track">
            {loop.map((p, i) => (
              <div
                key={`${p.name}-${i}`}
                data-testid={`partner-logo-${i}`}
                className="partners-item"
                title={p.name}
              >
                <img
                  src={p.src}
                  alt={p.name}
                  loading="lazy"
                  className="max-h-20 md:max-h-24 max-w-[180px] md:max-w-[220px] w-auto h-auto object-contain"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
